import React, { useEffect, useRef, useState } from "react";
import { openPopup } from "../../stateManagement/actions/popupActions";

import { Loader } from "../../components/loader/Loader";
import NoDataMessage from "../../components/manageEvents/NoEventsMessage";
import { InfoOutlined } from "@material-ui/icons";
import {
  usePortalTranslation,
  TranslationEnum,
} from "../../providers/TranslationProvider";
import AttendanceCorrectionCard from "../../components/attendanceCorrection/AttendanceCorrectionCard";
import { AttendanceRecord, RequestBody } from "./attendanceCorrectionTypes";
import { fetchAttendanceData, filterAttendanceData, putRejectAttendanceRequest } from "./attendanceCorrectionService";

const AttendanceCorrection = () => {
  const { translate } = usePortalTranslation();
  const [loader, setLoader] = useState<boolean>(true);
  const attendanceData = useRef<AttendanceRecord[]>([]);

  const rejectAttendance = async (requestBody: RequestBody) => {
    try {
      const response = await putRejectAttendanceRequest(requestBody);
      if(response){
        openPopup("Success", translate(TranslationEnum.common_portal,"Attendance rejected successfully"), () => {});
        getAttendanceData();
      }
    } catch (error) {
      openPopup("Alert", translate(TranslationEnum.common_portal,"Issue in rejecting attendance"), () => {});
    }
  };
  const getAttendanceData = async () => {
    setLoader(true);
    try {
      const data = await fetchAttendanceData();
      attendanceData.current = filterAttendanceData(data);
      if (attendanceData.current?.length === 0) {
        openPopup("Alert", translate(TranslationEnum.common_portal,"No data found"), () => {});
      }
    } catch (error) {
      openPopup("Alert", translate(TranslationEnum.common_portal,"Issue in fetching data"), () => {});
    } finally {
      setLoader(false);
    }
  };

  useEffect(() => {
    getAttendanceData();
  }, []);

  const noDataMessage = (
    <div
      style={{
        height: "80vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <NoDataMessage
        icon={<InfoOutlined />}
        message={translate(TranslationEnum.common_portal, "No data available.")}
      />
    </div>
  );

  return (
    <div>
      {loader && <Loader />}
      {!loader && attendanceData.current?.length === 0 && noDataMessage}
      {!loader &&
        attendanceData.current?.length > 0 &&
        attendanceData.current?.map((attendance: AttendanceRecord) => (
          <AttendanceCorrectionCard
            key={attendance?.creationTime}
            rejectAttendance={rejectAttendance}
            userAttendanceInfo={attendance}
          />
        ))}
    </div>
  );
};
export default AttendanceCorrection;
